import React, { useEffect, useRef, useState } from 'react';
import Icon from '../../components/Icon';

// Компактный селект в стиле карточек статистики (без внешних зависимостей).
const StatDropdown = ({ value, options, onChange, dotColor }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    if (open) document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, [open]);

  const selected = options.find((o) => o.value === value) || options[0];

  return (
    <div className="stats-dropdown" ref={ref}>
      <button type="button" className="stats-dropdown-trigger" onClick={() => setOpen((v) => !v)}>
        {dotColor && <span className="stats-dot" style={{ background: selected?.color || dotColor }} />}
        <span className="stats-dropdown-value">{selected?.label}</span>
        <Icon name="chevron-down" size={14} />
      </button>

      {open && (
        <div className="stats-dropdown-menu" role="listbox">
          {options.map((option) => (
            <button
              key={option.value}
              type="button"
              className={`stats-dropdown-item${option.value === selected?.value ? ' active' : ''}`}
              onClick={() => {
                onChange(option.value);
                setOpen(false);
              }}
            >
              {dotColor && <span className="stats-dot" style={{ background: option.color || dotColor }} />}
              <span>{option.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default StatDropdown;
